import { render, staticRenderFns } from "./EquipoActivoForm.vue?vue&type=template&id=7c73a730&scoped=true&"
import script from "./EquipoActivoForm.vue?vue&type=script&lang=ts&"
export * from "./EquipoActivoForm.vue?vue&type=script&lang=ts&"
import style0 from "./EquipoActivoForm.vue?vue&type=style&index=0&id=7c73a730&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c73a730",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7c73a730', component.options)
    } else {
      api.reload('7c73a730', component.options)
    }
    module.hot.accept("./EquipoActivoForm.vue?vue&type=template&id=7c73a730&scoped=true&", function () {
      api.rerender('7c73a730', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/InventarioSim/EquipoActivoForm.vue"
export default component.exports